import {EuiSpacer, EuiTitle, EuiTab, EuiTabs} from "@elastic/eui";
import {ProductManagement} from "./ProductManagement";
import {AddonManagement} from "./AddonManagement";
import {useState} from "react";

export const InventoryManagement: React.FC = () => {
    const [selectedTab, setSelectedTab] = useState<string>('products');

    const onTabSelected = (tab: string) => {
        setSelectedTab(tab);
    }

    return (
        <>
            <EuiTabs>
                <EuiTab key='products' onClick={() => {onTabSelected('products')}} isSelected={selectedTab === 'products'}>Products</EuiTab>
                <EuiTab key='addons' onClick={() => {onTabSelected('addons')}} isSelected={selectedTab === 'addons'}>Addons</EuiTab>
            </EuiTabs>
            <EuiSpacer/>
            {selectedTab === 'products' && <ProductManagement/>}
            {selectedTab === 'addons' && <AddonManagement/>}
        </>
    )
}